var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6177 14.0578V6.90212L27 11.2399L25.4454 13.6172L23.4202 12.2407V17.4286C23.4202 19.5049 21.4648 21 19.2164 21C16.968 21 15.0126 19.5049 15.0126 17.4286C15.0126 15.3522 16.968 13.8571 19.2164 13.8571C19.7028 13.8571 20.1755 13.9271 20.6177 14.0578ZM1 21V18.1429H12.2101V21H1ZM1 15.2857V12.4286H12.2101V15.2857H1ZM1 9.57143V6.71429H17.8151V9.57143H1ZM1 3.85714V1H22.0189V3.85714H1ZM19.2164 18.1429C20.0636 18.1429 20.6177 17.7192 20.6177 17.4286C20.6177 17.138 20.0636 16.7143 19.2164 16.7143C18.3692 16.7143 17.8151 17.138 17.8151 17.4286C17.8151 17.7192 18.3692 18.1429 19.2164 18.1429Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.ede1abe8.svg";
export { ForwardRef as ReactComponent };